import { PiggyBank } from "lucide-react";
import type { FC } from "react";
import { GoalCategoryTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { Callout } from "web_myplann/Shared/Components/Callout";

const DESCRIPTION_BY_CATEGORY = {
	[GoalCategoryTypeEnum.Basic]:
		Resources.Goals.Detail.OwnFundsCallout.descriptionWithLoan,
	[GoalCategoryTypeEnum.Car]:
		Resources.Goals.Detail.OwnFundsCallout.descriptionWithLoan,
	[GoalCategoryTypeEnum.House]:
		Resources.Goals.Detail.OwnFundsCallout.descriptionWithLoan,
	[GoalCategoryTypeEnum.Pension]:
		Resources.Goals.Detail.OwnFundsCallout.descriptionRent,
	[GoalCategoryTypeEnum.Rent]:
		Resources.Goals.Detail.OwnFundsCallout.descriptionRent,
	[GoalCategoryTypeEnum.Student]:
		Resources.Goals.Detail.OwnFundsCallout.descriptionSavings,
	[GoalCategoryTypeEnum.Vacation]:
		Resources.Goals.Detail.OwnFundsCallout.descriptionSavings,
};

type Props = {
	category: GoalCategoryTypeEnum;
	onClick: () => void;
};

export const GoalOwnFundsCallout: FC<Props> = ({ category, onClick }) => {
	const { t } = useResource();

	return (
		<Callout
			color="blue"
			icon={PiggyBank}
			title={t(Resources.Goals.Detail.OwnFundsCallout.title)}
			description={t(DESCRIPTION_BY_CATEGORY[category])}
			onClick={onClick}
		/>
	);
};
